"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistSelector = void 0;

var _ = require("../..");

require("./PlaylistSelector.css");

var _react = _interopRequireWildcard(require("react"));

var _LottieLoading = require("../../molecules/LottieLoading");

var _PlaylistSkeleton = require("../../molecules/PlaylistSkeleton");

var _colors = require("../../util/colors");

var _excluded = ["isLocked", "playlists", "userProfile", "loggedInUser", "lockPlaylists", "withCreateOption", "onDidSelectPlaylist", "onDidCreateNewPlaylist", "onDidRequestLockedPlaylist", "onDidRequestCreateNewPlaylist", "onDidRequestRelationLockedPlaylist"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Helpers/Renderers
var UserPlaylists = function UserPlaylists(_ref) {
  var isLocked = _ref.isLocked,
      playlists = _ref.playlists,
      userProfile = _ref.userProfile,
      loggedInUser = _ref.loggedInUser,
      lockPlaylists = _ref.lockPlaylists,
      withCreateOption = _ref.withCreateOption,
      onDidSelectPlaylist = _ref.onDidSelectPlaylist,
      onDidCreateNewPlaylist = _ref.onDidCreateNewPlaylist,
      onDidRequestLockedPlaylist = _ref.onDidRequestLockedPlaylist,
      onDidRequestCreateNewPlaylist = _ref.onDidRequestCreateNewPlaylist,
      onDidRequestRelationLockedPlaylist = _ref.onDidRequestRelationLockedPlaylist,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      sortedPlaylists = _useState2[0],
      setSortedPlaylists = _useState2[1];

  var collectionsSortIndex = function collectionsSortIndex(collection) {
    if (collection.title === "Family") return 1;
    if (collection.title === "Homework") return 2;
    if (collection.title === "Favorites") return 19;
    if (collection.title === "Showcase") return 20;
    return 50;
  };

  (0, _react.useEffect)(function () {
    if ((!sortedPlaylists || sortedPlaylists.length === 0) && playlists && playlists.length > 0) {
      // Sort our playlists
      var playlistsForSort = _toConsumableArray(playlists);

      playlistsForSort.sort(function (a, b) {
        var aIdx = collectionsSortIndex(a);
        var bIdx = collectionsSortIndex(b);
        var delta = aIdx - bIdx;

        if (delta === 0) {
          delta = new Date(a.creation_time) - new Date(b.creation_time);
        } else if (Math.abs(delta) < 5) {
          delta = b.title.localeCompare(a.title);
        } else if (Math.abs(delta) < 20) {
          if (a.needs_creation_on_select && !b.needs_creation_on_select) {
            delta = -1;
          } else if (!a.needs_creation_on_select && b.needs_creation_on_select) {
            delta = 1;
          } else {
            delta = b.title.localeCompare(a.title);
          }
        } else {
          delta = ["Favorites", "Showcase", "Family", "Homework"].includes(a.title) ? -1 : 1;
        }

        return delta;
      });
      setSortedPlaylists(playlistsForSort);
    }
  }, [playlists]);

  var extractFirstName = function extractFirstName(name) {
    return name ? name.substr(0, name.indexOf(" ")) : "";
  };

  var extractLastName = function extractLastName(name) {
    return name ? name.substr(name.indexOf(" ")) : "";
  };

  var shouldShowPlaylist = function shouldShowPlaylist(isLocked, playlist, userProfile, loggedInUser) {
    var shouldShow = true;

    if (isLocked && parseInt(userProfile.user_id) !== parseInt(loggedInUser.user_id) && !["Showcase", "Favorites"].includes(playlist.title)) {
      shouldShow = false;
    }

    return shouldShow;
  };

  var firstName = userProfile ? extractFirstName(userProfile.name) : "";
  var lastName = userProfile ? extractLastName(userProfile.name) : "";
  var initials = (0, _.getInitials)(firstName, lastName);
  var userId = userProfile ? userProfile.user_id : null;

  var handleOnDidSelectPlaylist = function handleOnDidSelectPlaylist(playlist, userProfile, isShowcaseOrFavorites) {
    var isRelation = userProfile.user_id !== loggedInUser.user_id;

    if (isLocked && !isShowcaseOrFavorites && isRelation && typeof onDidRequestRelationLockedPlaylist === "function") {
      onDidRequestRelationLockedPlaylist(playlist, userProfile);
      return;
    } else if (isLocked && !isShowcaseOrFavorites && typeof onDidRequestLockedPlaylist === "function") {
      onDidRequestLockedPlaylist(playlist, userProfile);
      return;
    }

    if (playlist.needs_creation_on_select === true) {
      if (typeof onDidCreateNewPlaylist === "function") {
        onDidCreateNewPlaylist({
          name: playlist.title,
          private: false,
          color: 1
        });
      }
    } else {
      if (typeof onDidSelectPlaylist === "function") {
        onDidSelectPlaylist(playlist, userProfile);
      }
    }
  };

  var handleOnDidRequestCreateNewPlaylist = function handleOnDidRequestCreateNewPlaylist(e) {
    if (isLocked && typeof onDidRequestLockedPlaylist === "function") {
      onDidRequestLockedPlaylist(null, userProfile);
    } else if (!isLocked && typeof onDidRequestCreateNewPlaylist === "function") {
      onDidRequestCreateNewPlaylist(e);
    }
  };

  var renderPlaylist = function renderPlaylist(idx, isLocked, playlist, userProfile, loggedInUser) {
    var shouldShow = shouldShowPlaylist(isLocked, playlist, userProfile, loggedInUser);
    var isShowcaseOrFavorites = ["Showcase", "Favorites"].includes(playlist.title);
    var isHomeworkOrFamily = ["Homework", "Family"].includes(playlist.title);
    var upgradeIconColor = isLocked ? _.Color.Grey3 : _.Color.Black;
    if (!shouldShow) return null;
    return /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center",
      className: "playlist-info",
      justifyContent: "space-between",
      onClick: function onClick() {
        return handleOnDidSelectPlaylist(playlist, userProfile, isShowcaseOrFavorites);
      },
      key: "playlist-".concat(idx)
    }, /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center",
      className: "side-left"
    }, !playlist.needs_creation_on_select && /*#__PURE__*/_react.default.createElement(_.Element, {
      className: "color-square ".concat(_colors.COLLECTION_COLOR_INT_TO_CLASS_NAME_MAP[playlist.color])
    }), playlist.needs_creation_on_select && /*#__PURE__*/_react.default.createElement(_.Icon, {
      size: "16",
      type: _.Icon.Type.Upgrade,
      className: "create-suggested-btn",
      color: upgradeIconColor
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      className: "playlist-name ".concat(!playlist.public ? " shorten-names" : "", " ").concat(isLocked && !isShowcaseOrFavorites ? " unlock-names" : ""),
      type: _.Label.Type.Body,
      content: playlist.title,
      color: isLocked && !isShowcaseOrFavorites ? _.Color.Grey3 : _.Color.Black
    })), /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center",
      className: "side-right"
    }, !playlist.public && !isLocked && !isShowcaseOrFavorites && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Icon, {
      size: 16,
      type: _.Icon.Type.Lock,
      color: _.Color.Grey2
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      type: _.Label.Type.Body,
      content: "Private",
      color: _.Color.Grey2,
      marginLeft: "2",
      marginRight: "3"
    })), isLocked && !isShowcaseOrFavorites && /*#__PURE__*/_react.default.createElement(_.Label, {
      type: _.Label.Type.Body,
      content: "Unlock with Plus",
      color: _.Color.Grey2,
      marginLeft: "1",
      marginRight: "3"
    })));
  };

  var homeworkPlaylist = sortedPlaylists.find(function (playlist) {
    return playlist.title === "Homework";
  });
  var familyPlaylist = sortedPlaylists.find(function (playlist) {
    return playlist.title === "Family";
  });
  return /*#__PURE__*/_react.default.createElement(_.Column, _extends({
    className: "UserPlaylists"
  }, props), /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "user",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_.Avatar, {
    size: 40,
    className: "user-avatar",
    imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(userId),
    initials: initials
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    marginLeft: "2",
    className: "user-name",
    color: _.Color.Black,
    type: _.Label.Type.Heading5,
    content: "".concat(userProfile === null || userProfile === void 0 ? void 0 : userProfile.name, "'s playlists")
  })), sortedPlaylists.map(function (playlist, idx) {
    if (["Homework", "Family"].includes(playlist.title)) return null;
    return renderPlaylist(idx, isLocked, playlist, userProfile, loggedInUser);
  }), homeworkPlaylist && renderPlaylist('homework', isLocked, homeworkPlaylist, userProfile, loggedInUser), familyPlaylist && renderPlaylist('family', isLocked, familyPlaylist, userProfile, loggedInUser), withCreateOption === true && /*#__PURE__*/_react.default.createElement(_.Row, {
    key: "key-create",
    alignItems: "center",
    className: "playlist-info"
  }, /*#__PURE__*/_react.default.createElement(_.Row, {
    alignItems: "center",
    trkAction: "Create new playlist",
    className: "select-playlist-row create",
    onClick: handleOnDidRequestCreateNewPlaylist
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: _.Icon.Type.Upgrade,
    color: _.Color.Black
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "playlist-name",
    type: _.Label.Type.Body,
    content: "Create new playlist",
    color: _.Color.Black
  }))));
}; // Playlist Selector


var PlaylistSelector = function PlaylistSelector(_ref2) {
  var forceLoading = _ref2.forceLoading,
      loggedInUser = _ref2.loggedInUser,
      playlistsByUsers = _ref2.playlistsByUsers,
      onDidSelectPlaylist = _ref2.onDidSelectPlaylist,
      onDidCreateNewPlaylist = _ref2.onDidCreateNewPlaylist,
      onDidRequestLockedPlaylist = _ref2.onDidRequestLockedPlaylist,
      onDidRequestCreateNewPlaylist = _ref2.onDidRequestCreateNewPlaylist,
      onDidRequestRelationLockedPlaylist = _ref2.onDidRequestRelationLockedPlaylist;

  var handleDidSelectPlaylist = function handleDidSelectPlaylist(playlist, userProfile) {
    if (typeof onDidSelectPlaylist === "function") {
      onDidSelectPlaylist(playlist, userProfile);
    }
  };

  var handleDidRequestCreateNewPlaylist = function handleDidRequestCreateNewPlaylist() {
    if (typeof onDidRequestCreateNewPlaylist === "function") {
      onDidRequestCreateNewPlaylist();
    }
  };

  var handleDidCreateNewPlaylist = function handleDidCreateNewPlaylist(playlist) {
    if (typeof onDidCreateNewPlaylist === "function") {
      onDidCreateNewPlaylist(playlist);
    }
  };

  var handleDidRequestLockedPlaylist = function handleDidRequestLockedPlaylist(playlist, userProfile) {
    if (typeof onDidRequestLockedPlaylist === "function") {
      onDidRequestLockedPlaylist(playlist, userProfile);
    }
  };

  var handleDidRequestRelationLockedPlaylist = function handleDidRequestRelationLockedPlaylist(playlist, userProfile) {
    if (typeof onDidRequestRelationLockedPlaylist === "function") {
      onDidRequestRelationLockedPlaylist(playlist, userProfile);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "PlaylistSelector"
  }, (forceLoading || !playlistsByUsers || playlistsByUsers.length === 0) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PlaylistSkeleton.PlaylistSkeleton, null)), !forceLoading && playlistsByUsers && playlistsByUsers.length > 0 && playlistsByUsers.map(function (playlistsByUser) {
    var _userProfile$permissi;

    var playlists = playlistsByUser.playlists;
    var userProfile = playlistsByUser.userProfile;
    var withCreateOption = userProfile && loggedInUser ? parseInt(userProfile.user_id) === parseInt(loggedInUser.user_id) : false;
    return /*#__PURE__*/_react.default.createElement(UserPlaylists, {
      isLocked: ((_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : _userProfile$permissi.plan_type) !== "pro",
      marginBottom: 4,
      playlists: playlists,
      userProfile: userProfile,
      loggedInUser: loggedInUser,
      withCreateOption: withCreateOption,
      onDidRequestLockedPlaylist: handleDidRequestLockedPlaylist,
      onDidRequestRelationLockedPlaylist: handleDidRequestRelationLockedPlaylist,
      onDidCreateNewPlaylist: handleDidCreateNewPlaylist,
      onDidSelectPlaylist: handleDidSelectPlaylist,
      onDidRequestCreateNewPlaylist: handleDidRequestCreateNewPlaylist
    });
  }));
};

exports.PlaylistSelector = PlaylistSelector;